import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles, withMenuPortal } from './selectStyles';

export default function SelectTalent({ callback, value, width , border, usersFilter, placeholder, isMulti }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '220px', border })
        : withMenuPortal(makeDarkSelectStyles({ width: width || (isMulti ? '440px' : '220px'), border }));

    
    useEffect(() => {
        loadTalents().then(talents => {
            if (talents) {
                var built_talents = BuildTalents(talents, 1)
                var temp = []
                var temp_options = []

                built_talents.map((item, i) => {
                    //var t = userTalents.find(x => x.talent.id === item.id)

                    temp.push(item)

                    var option = null;

                   
                        option = {
                            label: usersFilter
                                ? getDefaultName(item.names)
                                : (
                                    <span className="talent-parent-option">
                                        {getDefaultName(item.names)}
                                    </span>
                                ),
                            value: item.id
                        }

                    temp_options.push(option)

                    item.childs.map((child, index) => {
                        temp_options.push({
                            label: usersFilter
                                ? `\u203A ${getDefaultName(child.names)}`
                                : (
                                    <span className="child-option">
                                        {'   » ' + getDefaultName(child.names)}
                                    </span>
                                ),
                            value: child.id
                        })

                        child.childs.map((grand_child, index) => {
                            temp_options.push({
                                label: usersFilter
                                    ? `\u203A\u203A ${getDefaultName(grand_child.names)}`
                                    : (
                                        <span className="grand-child-option">
                                            {'»» ' + getDefaultName(grand_child.names)}
                                        </span>
                                    ),
                                value: grand_child.id
                            })
                        })
                    })

                   

                })
                //
                setSelectOptions(temp_options);
                // callback()
                //setTalents(temp)
            }

        })
    }, [])

    const handleSelect = (e) => {
        if (isMulti) {
            const ids = e ? e.map((opt) => opt.value) : [];
            callback(ids, "talents");
        } else {
            callback(e && e.value, "talent");
        }
    }

    const selectValue = isMulti
        ? SelectOptions && value && Array.isArray(value)
            ? SelectOptions.filter((obj) => value.indexOf(obj.value) >= 0)
            : []
        : SelectOptions && SelectOptions.filter((obj) => obj.value == value);

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Talent"}
                    isClearable={true}
                    isMulti={!!isMulti}
                    classNamePrefix="cms-rs"
                    value={selectValue}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
            </div>
            
        </>
    )
}
